import type { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'

type startConversationEventArgs = {
  userId: number
  itemId: number | string | null | undefined
}

export const startConversationEvent = (args: startConversationEventArgs): TrackingEvent => {
  const { itemId, userId } = args

  const extra = {
    user_id: userId,
    item_id: itemId,
  }

  return {
    event: 'user.start_conversation',
    extra,
  }
}

type SellerMakeOfferStartEventArgs = {
  offerSessionId: string
  hasSuggestedPrices: boolean
  currencyCode: string
  currentPrice: number
  transactionId?: string
}

type SellerMakeOfferStartEventExtra = {
  offer_session_id: string
  has_suggested_prices: boolean
  currency: string
  current_price: number
  transaction_id?: string
}

export const sellerMakeOfferStartEvent = (args: SellerMakeOfferStartEventArgs) => {
  const { offerSessionId, hasSuggestedPrices, currencyCode, currentPrice, transactionId } = args

  const extra: SellerMakeOfferStartEventExtra = {
    offer_session_id: offerSessionId,
    has_suggested_prices: hasSuggestedPrices,
    currency: currencyCode,
    current_price: currentPrice,
    transaction_id: transactionId,
  }

  return {
    event: 'seller.make_offer_start',
    extra,
  }
}

type StartMakeOfferRequestEventArgs = {
  offerRequestSessionId: string
  hasSuggestedPrices: boolean
  currentPrice: number
  transactionId?: string
}

type StartMakeOfferRequestEventExtra = {
  offer_request_session_id: string
  has_suggested_prices: boolean
  current_price: number
  transaction_id?: string
}

export const startMakeOfferRequestEvent = (args: StartMakeOfferRequestEventArgs) => {
  const { offerRequestSessionId, hasSuggestedPrices, currentPrice, transactionId } = args

  const extra: StartMakeOfferRequestEventExtra = {
    offer_request_session_id: offerRequestSessionId,
    has_suggested_prices: hasSuggestedPrices,
    current_price: currentPrice,
    transaction_id: transactionId,
  }

  return {
    event: 'buyer.make_offer_request_start',
    extra,
  }
}

type MakeOfferEventArgs = {
  isBuyer: boolean
  transactionId: number
  offerRequestId?: number
  currentPrice: number
  offeredPrice: number
  offerRequestSessionId?: string
  offerSuggestionOptionNumber: number | null
  offerSessionId?: string
  pendingSellerOfferId?: number
}

type MakeOfferEventExtra = {
  transaction_id: number
  offer_id?: number
  current_price: number
  offered_price: number
  button_number: number | null
  offer_request_session_id?: string
  offer_session_id?: string
  pending_seller_offer_id?: number
}

export const makeOfferEvent = (args: MakeOfferEventArgs) => {
  const {
    isBuyer,
    currentPrice,
    offeredPrice,
    transactionId,
    offerRequestId,
    offerRequestSessionId,
    offerSuggestionOptionNumber,
    offerSessionId,
    pendingSellerOfferId,
  } = args

  const extra: MakeOfferEventExtra = {
    transaction_id: transactionId,
    offer_id: offerRequestId,
    offer_request_session_id: offerRequestSessionId,
    current_price: currentPrice,
    offered_price: offeredPrice,
    button_number: offerSuggestionOptionNumber,
    ...(offerSessionId !== undefined && { offer_session_id: offerSessionId }),
    ...(pendingSellerOfferId !== undefined && { pending_seller_offer_id: pendingSellerOfferId }),
  }

  return {
    event: isBuyer ? 'buyer.make_offer_request' : 'seller.make_offer',
    extra,
  }
}
